import React, {Component} from 'react';
import {
    Grid,
    withStyles,
    Paper,
    Typography,
} from 'material-ui';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {builderStyles} from '../../style/builder';
import classNames from 'classnames';
import {getActiveSections} from '../../selectors/active_sections';
import PageBuilderWarning from '../../PageBuilderWarning';
import SectionListSettings from './SectionList';
import Sticky from 'react-sticky-el';
import {fetchTemplate, saveTemplate} from '../../../thunks';
import {
    deleteTemplateSection,
    moveSection,
    updateNewPlaceholder,
    openEditPlaceholderPopup,
    closeEditPlaceholderPopup,
    doneEditPlaceholder,
    disableSection, enableSection
} from '../../../actions';
import DeleteDialog from '../../form/DeleteSectionDialog';
import EnableDialog from '../../form/EnableDialog';
import DisableDialog from '../../form/DisableDialog';
import PlaceholderPopup from '../../form/PlaceholderPopup';
import {
    showToasterWarningMessage,
    showToasterInfoMessage
} from '../../../../../components/helpers/helpers';
import {BackButton} from '../../../../../components/buttons/BackButton';
import ScrollToTop from '../../../../../components/scroll-top/ScrollToTop';

class PageTemplate extends Component {

    constructor(props) {
        super(props);
        this.moveTheSection = this.moveTheSection.bind(this);
    }

    state = {
        openDeleteDialog: false,
        toDeleteSectionId: null,
        openEnableDialog: false,
        toEnableSectionId: null,
        openDisableDialog: false,
        toDisableSectionId: null,
    };

    componentDidMount() {
        this.props.getTemplate(this.props.templateId);
        showToasterWarningMessage('The order in which the sections are saved on this template will reflect the order of the sections on the website!');
        showToasterInfoMessage('Please enable your browser to ALLOW POP-UPS in order to open the template PREVIEW!');
    }

    componentWillUnmount() {
        toastr.removeByType('warning');
        toastr.removeByType('info');
    }

    moveTheSection(dragIndex, hoverIndex) {
        const {pageSections, moveSection } = this.props;

        moveSection(
            dragIndex,
            hoverIndex,
            pageSections[dragIndex]
        );
    }

    handleTemplateSave = () => {
        this.props.saveTemplate(
            this.props.templateId,
            this.props.template,
            false
        );
    }

    handleDisableSection = () => {
        this.props.disableSection(
            this.props.templateId,
            this.state.toDisableSectionId
        );
        this.setState({
            openDisableDialog: false,
            toDisableSectionId: null
        });
    }

    handleEnableSection = () => {
        this.props.enableSection(
            this.props.templateId,
            this.state.toEnableSectionId
        );
        this.setState({
            openEnableDialog: false,
            toEnableSectionId: null
        });
    }

    handleSavePreview = () => {
        this.props.saveTemplate(
            this.props.templateId,
            this.props.template,
            true
        );
    };

    render() {
        const {pageSections, template } = this.props;

        const {isOver, canDrop, classes } = this.props;

        let className = '';

        if (isOver && canDrop) {
            className += ' green';
        }

        if (!isOver && canDrop) {
            className += ' yellow';
        }

        if (isOver && !canDrop) {
            className += ' red';
        }

        const buttonClassName = classNames({
            [classes.saveButton]: !this.props.loading,
            [classes.disabledSaveButton]: this.props.loading,
        });

        let saveButtonLabel = this.props.loading ? '' : 'save';

        return (
            !this.props.loading &&
            <Grid className={classNames('pb-sections', className)} item xs={9} sm={9}>

                <Sticky className={classes.saveWarning}>
                    <PageBuilderWarning
                        isDirty={this.props.isDirty}
                        classes={this.props.classes}
                        buttonClassName={buttonClassName}
                        loading={this.props.loading}
                        saveButtonLabel={saveButtonLabel}
                        handleTemplateSave={this.handleTemplateSave}
                        handleSetPreview={this.handleSavePreview}
                        handleTemplateDiscard={() => {
                            this.props.getTemplate(
                                this.props.templateId
                            );
                        }}
                    />
                </Sticky>

                <Paper elevation={2} className={classes.marginBottom10}>
                    <Typography variant="subheading" className={classes.headingTitle}>Edit Template: {template.template}</Typography>
                </Paper>

                <PlaceholderPopup
                    open={this.props.openPlaceholderPopup}
                    onPlaceholderChange={(newPlaceholder) => {
                        this.props.updateNewPlaceholder(newPlaceholder)
                    }}
                    placeholder={this.props.newPlaceholder}
                    onHandleClose={() => {
                        this.props.closeEditPlaceholderPopup()
                    }}
                    onHandleSubmit={() => {
                        this.props.doneEditPlaceholder(this.props.newPlaceholder);
                    }}
                />

                <SectionListSettings
                    pageSections={pageSections}
                    pageId={this.props.pageId}
                    moveTheSection={this.moveTheSection}
                    hideActions={false}
                    showEnableSectionDialog={(ev, sectionId) => {
                        this.setState({
                            openEnableDialog: true,
                            toEnableSectionId: sectionId
                        });
                    }}
                    showDisableSectionDialog={(ev, sectionId) => {
                        this.setState({
                            openDisableDialog: true,
                            toDisableSectionId: sectionId
                        });
                    }}
                    showDeleteSectionDialog={(ev, sectionId) => {
                        this.setState({
                            openDeleteDialog: true,
                            toDeleteSectionId: sectionId
                        });
                    }}
                />

                <EnableDialog
                    open={this.state.openEnableDialog}
                    handleEnable={this.handleEnableSection}
                    handleCloseDialog={() => {
                        this.setState({
                            openEnableDialog: false,
                            toEnableSectionId: null
                        });
                    }}
                    classes={classes}
                />

                <DisableDialog
                    open={this.state.openDisableDialog}
                    handleDisable={this.handleDisableSection}
                    handleCloseDialog={() => {
                        this.setState({
                            openDisableDialog: false,
                            toDisableSectionId: null
                        });
                    }}
                    classes={classes}
                />

                <DeleteDialog
                    open={this.state.openDeleteDialog}
                    classes={this.props.classes}
                    handleDelete={() => {
                        this.props.deleteTemplateSection(
                            this.state.toDeleteSectionId
                        );
                        this.setState({
                            openDeleteDialog: false,
                            toDeleteSectionId: null
                        });
                    }}
                    handleCloseDialog={() => {
                        this.setState({
                            openDeleteDialog: false,
                            toDeleteSectionId: null
                        });
                    }}
                />
                
                <Grid container spacing={16}>
                    <Grid item xs={12} className={classes.backButton}>
                        <BackButton
                            link={"/templates"}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>

                <ScrollToTop />
            </Grid>
        )
    }
}

const mapStateToProps = (state, props) => {
    let pageSections = state.template.template.data !== undefined ?
        state.template.template.data : [];

    return {
        template: state.template.template,
        pageSections: getActiveSections(pageSections),
        allSections: pageSections,
        isDirty: state.template.isDirty,
        loading: state.layout.ajaxCallsInProgress > 0,
        newPlaceholder: state.template.newPlaceholder,
        openPlaceholderPopup: state.template.editPlaceholderPopup.open,
    }
}

export default connect(
    mapStateToProps, {
        getTemplate: fetchTemplate,
        moveSection: moveSection,
        saveTemplate: saveTemplate,
        deleteTemplateSection: deleteTemplateSection,
        updateNewPlaceholder: updateNewPlaceholder,
        openEditPlaceholderPopup: openEditPlaceholderPopup,
        closeEditPlaceholderPopup: closeEditPlaceholderPopup,
        doneEditPlaceholder: doneEditPlaceholder,
        disableSection: disableSection, 
        enableSection: enableSection
    }
)(withStyles(builderStyles)(PageTemplate))


// WEBPACK FOOTER //
// ./src/containers/templates/builder/sections/tab_dnd/Sections.jsx